"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PASSPORT = void 0;
var entities_1 = require("@common/entities");
var DONT_HAVE_FIELD_NAME_1 = require("./DONT_HAVE_FIELD_NAME");
exports.PASSPORT = {
    name: 'passport',
    label: 'Passport',
    customType: entities_1.IDTypes.Passport,
    elementType: entities_1.SectionElementType.Block,
    fields: [
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            label: 'Passport',
            name: entities_1.IdTypeFields.value.name,
            required: false,
            sequence: 1,
            type: entities_1.FieldType.Text,
        },
        {
            customType: entities_1.FieldType.Date,
            enabled: true,
            label: 'Issue Date',
            name: entities_1.IdTypeFields.issueDate.name,
            required: false,
            sequence: 2,
            type: entities_1.FieldType.Date,
        },
        {
            customType: entities_1.FieldType.Date,
            enabled: true,
            label: 'Expiration Date',
            name: entities_1.IdTypeFields.expiryDate.name,
            required: false,
            sequence: 3,
            type: entities_1.FieldType.Date,
        },
        {
            customType: entities_1.FieldType.CountryDropdown,
            enabled: true,
            label: 'Country',
            name: entities_1.IdTypeFields.countryCode.name,
            required: false,
            sequence: 4,
            type: entities_1.FieldType.CountryDropdown,
            options: [],
        },
        {
            customType: entities_1.FieldType.StateDropdown,
            enabled: true,
            label: 'State',
            name: entities_1.IdTypeFields.stateCode.name,
            required: false,
            sequence: 5,
            type: entities_1.FieldType.StateDropdown,
            options: [],
        },
        {
            customType: entities_1.FieldType.Checkbox,
            enabled: false,
            label: "I don't have a Passport.",
            name: DONT_HAVE_FIELD_NAME_1.ID_TYPE_DONT_HAVE_FIELD_NAME_MAPPING[entities_1.IDTypes.Passport],
            required: false,
            sequence: 6,
            type: entities_1.FieldType.Checkbox,
        },
    ],
};
